import { TeamListSort } from 'modules/donor/components/TeamsTable/interfaces';
import { getTranslation } from 'utils/getTranslation';

const t = getTranslation('donor.TeamsCardListSorter');

export const options = [
  {
    value: TeamListSort.Title,
    label: t('teamName'),
  },
  {
    value: TeamListSort.Total,
    label: t('total'),
  },
];
